import { Book, Dices, FlaskConical, Home, Map, Scale, Sparkles, Swords, Users, WandSparkles } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { createPageUrl } from '@/utils/routing';

export type MobileNavGroupId = 'compendium' | 'campaigns' | 'tools';

export interface MobileNavMenuItem {
  title: string;
  url: string;
  icon: LucideIcon;
}

export interface MobileNavGroupDefinition {
  id: MobileNavGroupId;
  title: string;
  icon: LucideIcon;
  items: MobileNavMenuItem[];
}

export const MOBILE_NAV_GROUP_ORDER = ['compendium', 'campaigns', 'tools'] as const;

export const MOBILE_NAV_GROUP_OPTIONS: MobileNavGroupDefinition[] = [
  {
    id: 'compendium',
    title: 'Codex',
    icon: Book,
    items: [
      { title: 'Compendium', url: createPageUrl('Compendium'), icon: Book },
      { title: 'Rules', url: createPageUrl('Rules'), icon: Scale },
    ],
  },
  {
    id: 'campaigns',
    title: 'Builds',
    icon: Map,
    items: [
      { title: 'Campaigns', url: createPageUrl('Campaigns'), icon: Map },
      { title: 'My Characters', url: createPageUrl('MyCharacters'), icon: Users },
      { title: 'Homebrew', url: createPageUrl('Homebrew'), icon: FlaskConical },
      { title: 'Spell Book', url: createPageUrl('SpellBook'), icon: WandSparkles },
    ],
  },
  {
    id: 'tools',
    title: 'Tools',
    icon: Swords,
    items: [
      { title: 'Generators', url: createPageUrl('Generators'), icon: Sparkles },
      { title: 'Combat Tracker', url: createPageUrl('CombatTracker'), icon: Swords },
    ],
  },
];

export const MOBILE_NAV_HOME = { title: 'Home', url: '/', icon: Home };
export const MOBILE_NAV_DICE = { title: 'Dice', icon: Dices };

export const MOBILE_NAV_GROUP_OPTIONS_BY_ID: Record<MobileNavGroupId, MobileNavGroupDefinition> =
  MOBILE_NAV_GROUP_OPTIONS.reduce(
    (acc, item) => {
      acc[item.id] = item;
      return acc;
    },
    {} as Record<MobileNavGroupId, MobileNavGroupDefinition>
  );
